import logo from './logo.svg';
import MenuBG from './menu-bg.png';
import homeSlideOne from './home-slide-one.png';
import houseBannerOne from './house-banner-one.png';
import houseOneInfo from './house-one-info.png';
import houseTwoInfo from './house-info-two.JPG';
import houseOneFac1 from './house-one-fac-1.JPG';
import houseOneFac2 from './house-one-fac-2.png';
import houseTwoFac1 from './house-two-fac-1.JPG';
import houseTwoFac2 from './house-two-fac-2.JPG';
import testimony from './testimony.JPG';
import homeLocOne from './home-loc-one.png';
import homeLocTwo from './home-loc-two.png';
import homeHouseOne from './home-house-one.png';
import homeHouseTwo from './home-house-two.png';
import aboutTwo from './about-two.JPG';
// House Of Arie 1
import HouseOneCarousel1 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(1).JPG'
import HouseOneCarousel2 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(2).JPG'
import HouseOneCarousel3 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(3).JPG'
import HouseOneCarousel4 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(4).JPG'
import HouseOneCarousel5 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(5).JPG'
import HouseOneCarousel6 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(6).JPG'
import HouseOneCarousel7 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(7).JPG'
import HouseOneCarousel8 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(8).JPG'
import HouseOneCarousel9 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(9).JPG'
import HouseOneCarousel10 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(10).JPG'
import HouseOneCarousel11 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(11).JPG'
import HouseOneCarousel12 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(12).JPG'
import HouseOneCarousel13 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(13).JPG'
import HouseOneCarousel14 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(14).JPG'
import HouseOneCarousel15 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(15).JPG'
import HouseOneCarousel16 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(16).JPG'
import HouseOneCarousel17 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(17).JPG'
import HouseOneCarousel18 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(18).JPG'
import HouseOneCarousel19 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(19).JPG'
import HouseOneCarousel20 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(20).JPG'
import HouseOneCarousel21 from './house-one-carousel/House-of-Arie-1-Kost-Khusus-Putri-Jakarta-Selatan(21).JPG'
// House Of Arie 2
import HouseTwoCarousel1 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan1.JPG'
import HouseTwoCarousel2 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan2.JPG'
import HouseTwoCarousel3 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan3.JPG'
import HouseTwoCarousel4 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan4.JPG'
import HouseTwoCarousel5 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan5.JPG'
import HouseTwoCarousel6 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan6.JPG'
import HouseTwoCarousel7 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan7.JPG'
import HouseTwoCarousel8 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan8.JPG'
import HouseTwoCarousel9 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan9.JPG'
import HouseTwoCarousel10 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan10.JPG'
import HouseTwoCarousel11 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan11.JPG'
import HouseTwoCarousel12 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan12.JPG'
import HouseTwoCarousel13 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan13.JPG'
import HouseTwoCarousel14 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan14.JPG'
import HouseTwoCarousel15 from './house-two-carousel/House-of-Arie-2-Kost-Khusus-Putri-Jakarta-Selatan15.JPG'
// Home Carousel
import HomeCarousel1 from './home-carousel/House-of-Arie-Kost-Khusus-Putri-Jakarta-Selatan1.png';
import HomeCarousel2 from './home-carousel/House-of-Arie-Kost-Khusus-Putri-Jakarta-Selatan2.png';
import HomeCarousel3 from './home-carousel/House-of-Arie-Kost-Khusus-Putri-Jakarta-Selatan3.png';
import HomeCarousel4 from './home-carousel/House-of-Arie-Kost-Khusus-Putri-Jakarta-Selatan4.JPG';

const houseOneCarousel = [
  HouseOneCarousel1,
  HouseOneCarousel2,
  HouseOneCarousel3,
  HouseOneCarousel4,
  HouseOneCarousel5,
  HouseOneCarousel6,
  HouseOneCarousel7,
  HouseOneCarousel8,
  HouseOneCarousel9,
  HouseOneCarousel10,
  HouseOneCarousel11,
  HouseOneCarousel12,
  HouseOneCarousel13,
  HouseOneCarousel14,
  HouseOneCarousel15,
  HouseOneCarousel16,
  HouseOneCarousel17,
  HouseOneCarousel18,
  HouseOneCarousel19,
  HouseOneCarousel20,
  HouseOneCarousel21
];

const houseTwoCarousel = [
  HouseTwoCarousel1,
  HouseTwoCarousel2,
  HouseTwoCarousel3,
  HouseTwoCarousel4,
  HouseTwoCarousel5,
  HouseTwoCarousel6,
  HouseTwoCarousel7,
  HouseTwoCarousel8,
  HouseTwoCarousel9,
  HouseTwoCarousel10,
  HouseTwoCarousel11,
  HouseTwoCarousel12,
  HouseTwoCarousel13,
  HouseTwoCarousel14,
  HouseTwoCarousel15
];

const homeCarousel = [
  {
    image: HomeCarousel1,
    text: 'Kamar House Of Arie 1'
  },
  {
    image: HomeCarousel2,
    text: 'Kamar House Of Arie 2'
  },
  {
    image: HomeCarousel3,
    text: 'Ruang Tamu'
  },
  {
    image: HomeCarousel4,
    text: 'Balkon Kamar'
  }
];

const Images = {
  logo,
  menu: MenuBG,
  homeSlideOne,
  houseBannerOne,
  houseOneInfo,
  houseTwoInfo,
  houseOneFac1,
  houseOneFac2,
  houseTwoFac1,
  houseTwoFac2,
  testimony,
  homeLocOne,
  homeLocTwo,
  homeHouseOne,
  homeHouseTwo,
  aboutTwo,
  houseOneCarousel,
  houseTwoCarousel,
  homeCarousel
};

export default Images;
